import { render } from "./ReportCriterionDateRange.vue?vue&type=template&id=1a56bb3a&scoped=true"
import script from "./ReportCriterionDateRange.vue?vue&type=script&lang=js"
export * from "./ReportCriterionDateRange.vue?vue&type=script&lang=js"

import "./ReportCriterionDateRange.vue?vue&type=style&index=0&id=1a56bb3a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a56bb3a"]])

export default __exports__